<template>
  <div class="form-group" id="order-by-group">
    <label for="orderBySelect">Order By:</label>
    <div class="d-inline-block" style="width: auto">
      <select
        class="selectpicker form-control ml-2"
        style="display: initial; width: auto;"
        id="orderBySelect"
        name="orderBySelectPicker"
        data-width="auto"
        v-model="selectedOption"
        v-on:change="orderByChanged"
      >
        <option
          v-for="option in orderByOptions"
          :key="option.value"
          v-bind:value="option.value"
          >{{ option.description }}</option
        >
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "GrantOrderBy",
  props: {
    SelectedOption: {
      type: String,
      default: "Date_Added"
    }
  },
  data() {
    return {
      orderByOptions: [
        { value: "Date_Added", description: "Newest" },
        { value: "Application_Deadline", description: "Application Due" },
        { value: "Title", description: "Title" },
        { value: "Organization", description: "Organization" }
      ],
      selectedOption: this.SelectedOption
    };
  },
  created() {
    if (this.$route.path.includes("/managegrants")) {
      this.orderByOptions.push({ value: "Grant_Id", description: "Id" });
    }
  },
  methods: {
    orderByChanged() {
      this.$emit("orderByChanged", this.selectedOption);
    }
  }
};
</script>

<style scoped>
div.dropdown.bootstrap-select.form-control.ml-2 {
  max-width: 70% !important;
}
</style>
